import { useMutation } from '@tanstack/react-query';

import { mutationFn } from '@/lib/react-query';
import { apiRoutes } from '@/utils/routes';

// TODO: Missing types
const createHelpdeskTicketMessageFn = (ticketId: number, data: any) => {
  return mutationFn(apiRoutes.createHelpdeskTicketMessage(ticketId), data);
};

export const useCreateHelpdeskTicketMessage = (ticketId: number) =>
  useMutation({
    mutationFn: (data: any) => createHelpdeskTicketMessageFn(ticketId, data),
  });
